/* global API */

import debounce from 'lodash/debounce';

const OVERLAY_CLASS = '.js-media-browser-overlay';
const CLOSE_CLASS = '.js-media-browser-close';
const LIST_CLASS = '.js-media-browser-list';
const SEARCH_INPUT_CLASS = '.js-media-browser-search';
const ALBUM_CLASS = '.js-media-browser-album';
const SUBMIT_CLASS = '.js-media-browser-submit';
const PAGE_CLASS = '.js-media-page';

const STORE_ALBUM_CHOICE = true;

const Browser = {
  create(node, options) {
    this.node = node;
    this.options = options;

    this.$list = $(this.node).find(LIST_CLASS);
    this.$submit = $(this.node).find(SUBMIT_CLASS);

    this.filters = {
      search: '',
      album: 'all',
      type: 'all',
      page: 1,
    };

    this.debouncedSearch = debounce(this.search.bind(this), 150);

    this.createEventListeners();

    if (STORE_ALBUM_CHOICE) {
      this.retrieveCategory();
    }
  },

  createEventListeners() {
    $(document).on('browser:open', (e, id, type = 'all') => {
      this.inputID = id;
      this.filters.type = type;
      this.openBrowser();
    });

    $(document).on('click', CLOSE_CLASS, () => {
      this.closeBrowser();
    });

    window.pubsub.subscribe('media:filter', () => {
      this.fetchList();
    });

    $(this.node).on('keyup', SEARCH_INPUT_CLASS, (e) => {
      this.filters.page = 1;
      this.debouncedSearch(e.currentTarget.value);
    });

    $(this.node).on('change', ALBUM_CLASS, (e) => {
      this.filters.page = 1;
      this.changeAlbum(e.currentTarget.value);
    });

    $(this.node).on('change', `${LIST_CLASS} input[type="checkbox"]`, () => {
      this.checkSelected();
    });

    $(this.node).on('change', PAGE_CLASS, () => {
      this.filters.page = parseInt($(this.node).find(PAGE_CLASS).val(), 10);
      this.fetchList();
    });

    $(this.node).on('media:filtered', LIST_CLASS, () => {
      this.checkSelected();
    });

    $(this.node).on('click', SUBMIT_CLASS, () => {
      this.addMedia();
    });
  },

  toggleBrowser(state) {
    $(this.node).add(OVERLAY_CLASS).toggleClass('is-open', state);
  },

  openBrowser() {
    this.toggleBrowser(true);
    this.fetchList();
  },

  closeBrowser() {
    this.toggleBrowser(false);
  },

  getOptions() {
    return {
      folders: [this.filters.album],
      search: this.filters.search,
      type: this.filters.type,
      page: this.filters.page,
    };
  },

  fetchList() {
    window.axios.post(API.media.listUrl, this.getOptions())
      .then((item) => {
        this.outputList(item.data);
      });
  },

  search(val) {
    this.filters.search = val;
    this.fetchList();
  },

  changeAlbum(val) {
    this.filters.album = val;
    this.fetchList();

    if (STORE_ALBUM_CHOICE) {
      this.saveCategory(val);
    }
  },

  saveCategory(val) {
    window.localStorage.setItem('browser_category', val);
  },

  retrieveCategory(val) {
    const category = window.localStorage.getItem('browser_category', val);

    if (category) {
      $(this.node).find(ALBUM_CLASS).val(category);
      this.filters.album = category;
    }
  },

  outputList(html) {
    const $list = $(this.node).find(LIST_CLASS);
    $list.html(html);
    $list.trigger('media:filtered');

    $list.animate({
      scrollTop: 0,
    }, 40);
  },

  checkSelected() {
    const $checked = this.getSelected();
    this.$submit.prop('disabled', !$checked.length);
  },

  getSelected() {
    return this.$list.find('input[type="checkbox"]:checked');
  },

  addMedia() {
    const selectedIds = this.getSelected().toArray().map((check) => {
      const $parent = $(check).parents('.js-media-item');
      const id = $parent.data('item-id');
      return id;
    });

    $(document).trigger('browser:selected', {
      id: this.inputID,
      selected: selectedIds,
    });

    this.closeBrowser();
  },
};

export default Browser;
